export default "__VITE_ASSET__cf3f57b3__"